import { FileExtensions } from "../types/_enums"

const downloadCSVFromJSON = (data: any[], header: string[], fields: string[], fileName: string) => {
  // handle null values in data
  const replacer = (key: string, value: string | null) => (value === null) ? "" : value
  const csv = data.map((row) => fields.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(","))
  // add headers
  csv.unshift(header.join(','))
  const csvArray = csv.join("\r\n")
  // generate file
  const a = document.createElement('a')
  const blob = new Blob([csvArray], { type: 'text/csv' })
  const url = window.URL.createObjectURL(blob)
  // download file
  a.href = url
  a.download = fileName
  a.click()
  // cleanup
  window.URL.revokeObjectURL(url)
  a.remove()
}

export const downloadCSVFromString = (data: string, fileName: string, type: FileExtensions) => {
  const blob = new Blob([ type === FileExtensions.JSON ? JSON.stringify(data) :  data], { type: 'text/csv' })
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  // cleanup
  window.URL.revokeObjectURL(url)
  a.remove()
}

export default downloadCSVFromJSON;
